import React from "react";

import Accueil from '../../assets/images/Vapeur/Vapeur_Accueil.png'; // Image est en 1600x900
import AddGame from '../../assets/images/Vapeur/Vapeur_AddGame.png';
import Code from '../../assets/images/Vapeur/Vapeur_Code.png';

function Project_vapeur() {
    return(
    <div className="projects-windows" id="projects">
        <h1>Vapeur</h1>

        <h2>Le contexte et la problématique du projet</h2>
        <p>Vapeur est un projet universitaire qui cherche à créer une bibliothèque de jeux en ligne, 
            à la manière de Steam. Le but est de créer un site web qui permettrait à n'importe qui 
            de pouvoir ajouter leurs propres jeux et éditeurs, de manière simple et efficace.</p><br></br>

            <img id="img"src={Accueil} alt="Accueil du site" />

            <p>Accueil du site</p><br></br>
            <h2>Les objectifs poursuivis</h2>
            <p>Afin de répondre a toute les attentes, une liste détaillé de tous les fonctionnalité a été dressé avant le début du projet :</p> 
            <ul>
                <li>-Afficher la liste des jeux mis en avant sur la page d'accueil</li>
                <li>-Afficher la liste de tous les jeux</li>
                <li>-Création d'un jeu</li>
                <li>-Afficher le détail d'un jeu (avec ses infos, son genre et son éditeur)</li>
                <li>-Modification d'un jeu (nom, description, date de sortie, genre, éditeur)</li>
                <li>-Suppression d'un jeu</li>
                <li>-Possibilité d'afficher le jeux sur la page d'accueil (mise en avant)</li>
                <li>-Afficher la liste des genres</li>
                <li>-Afficher la liste des jeux d'un genre</li>
                <li>-Création d'un éditeur</li>
                <li>-Afficher la liste des éditeurs</li>
                <li>-Afficher la liste des jeux d'un éditeur</li>
                <li>-Modification d'un éditeur</li>
                <li>-Suppression d'un éditeur</li>
            </ul><br></br>

            <h2>Les compétences mobilisées (techniques, transversales et humaines)</h2>
            <p>Outils utilisés : Node.js, Prisma, Handlebars, Visual Studio, Git, Express.js, SQLite.</p>
            <p>Compétences transversales : Travail d'équipe, gestion du temps, cahier des charges, autonomie, bonnes pratiques de programmation, organisation.</p>
            <br></br>

            <img id="img" src={AddGame} alt="Ajout d'un jeu" />
            <p>Ajout d'un jeu</p><br></br>
            <h2>Les missions principales</h2>
            <p>Une fois entrés dans le vif du sujet, nous avons commencé par les étapes suivantes :</p>

            <ul>
                <ol>Structure du projet : Nous avons mis en place le système de routes, qui sera utilisé 
                    pour la gestion des pages que contiendra le site. Ainsi, chaque page possède son propre 
                    fichier JavaScript, ce qui nous facilitera le développement du site plus tard.</ol>

                <ol>Création de la base de données : Cette étape est cruciale puisque tout le site va se 
                    baser sur le résultat des requêtes. Nous avons donc trois tables au final.</ol>

                <ol>Création des différentes fonctionnalités CRUD : L'ajout, la modification des jeux, 
                    des éditeurs, etc.</ol>

                <ol>Conception du site : Nous avons conçu le site pour être accessible à tous, puisqu'il 
                    est responsive et peut donc être utilisé à la fois sur tablette et téléphone. 
                    Enfin, il utilise des designs sobres pour éviter de charger trop d'éléments sur chaque
                    page, et ainsi, être disponible même avec des connexions plus limitées.</ol>
            </ul>
            <br></br>
            <img id="img"src={Code} alt="Ajout d'un jeu" />
            <p>Exemple d'ajout d'un jeu</p><br></br>
            <h2>Conclusion réflexive</h2>
            <p>Une fois lancé, nous avons pu mettre en place toutes les compétences apprises lors de cette 
            année de BUT. Nous avons donc pu commencer par la structure du projet, puis la création de la base 
            de données, et enfin, la création des différentes fonctionnalités CRUD</p>
            <p>Au final, ce projet est une réussite puisque tous les points précédents ont été réalisés 
                dans les temps. Ainsi, Vapeur est parfaitement opérationnel. Grâce à ce projet, 
                nous avons mieux compris les différentes étapes de création, de la phase de test jusqu'à la 
                production. Nous avons également pu découvrir le domaine du web, qui nous semblait encore 
                abstrait il y a quelque temps, et nous a permis de mieux nous familiariser avec ces 
                technologies, et de mieux nous préparer pour les futurs défis web.</p>
    </div>
    );
}

export default Project_vapeur;

